import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { Button, Form, Input, Spin, Alert, Select } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import GoogleOperatorAuth from "../components/auth/GoogleOperatorAuth";
import "../assets/styles/login.scss";
import axios from "axios";
import { Link } from "react-router-dom";

const { Option } = Select;

const Registration = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("KG");
  const [phoneInputValue, setPhoneInputValue] = useState("");

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const countries = [
    { code: "KG", flag: "🇰🇬", prefix: "+996", format: "xxx xx-xx-xx" },
    { code: "KZ", flag: "🇰🇿", prefix: "+7", format: "xxx xxx-xx-xx" },
    { code: "UZ", flag: "🇺🇿", prefix: "+998", format: "xx xxx-xx-xx" },
    { code: "RU", flag: "🇷🇺", prefix: "+7", format: "xxx xxx-xx-xx" },
    { code: "BY", flag: "🇧🇾", prefix: "+375", format: "xx xxx-xx-xx" },
  ];

  const handleCountryChange = (value) => {
    setSelectedCountry(value);
  };

  const handlePhoneInputChange = (e) => {
    setPhoneInputValue(e.target.value);
  };

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const onSubmit = async (values) => {
    // Remove confirm_password as it's not needed for the API request
    const { confirm_password, ...registrationData } = values;

    // Get country prefix without + symbol
    const country = countries.find((c) => c.code === selectedCountry);
    const countryPrefix = country.prefix.replace("+", "");

    // Combine country code with phone number (remove any existing country code)
    const phoneDigits = phoneInputValue.replace(/\D/g, "");
    if (!phoneDigits) {
      setError("Введите номер телефона");
      return;
    }

    const phoneWithCountryCode = countryPrefix + phoneDigits;

    const payload = {
      ...registrationData,
      phone_number: phoneWithCountryCode,
      role: "DISPATCHER",
      avatar: null,
      is_active_operator: false,
    };

    setError(null);
    setLoading(true);
    try {
      const { status } = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/users/`,
        payload,
      );

      if (status === 201) {
        setSuccess(true);
      }
    } catch (error) {
      console.log("error", error);

      // Handle different error response formats
      let errorMessage = "Произошла ошибка при регистрации";

      if (error.response) {
        // Server responded with error status
        const { data, status } = error.response;

        if (status === 500) {
          errorMessage =
            "Внутренняя ошибка сервера. Пожалуйста, попробуйте позже.";
        } else if (data && typeof data === "object") {
          // Handle field-specific errors like password validation
          if (data.password && Array.isArray(data.password)) {
            errorMessage = data.password.join(", ");
          } else if (data.username && Array.isArray(data.username)) {
            const usernameErrors = data.username.map((error) => {
              if (error.includes("Username exists") || error.includes("-3")) {
                return "Пользователь с таким именем уже существует";
              }
              return error;
            });
            errorMessage = usernameErrors.join(", ");
          } else if (data.email && Array.isArray(data.email)) {
            errorMessage = data.email.join(", ");
          } else if (data.phone_number && Array.isArray(data.phone_number)) {
            errorMessage = data.phone_number.join(", ");
          } else if (data.first_name && Array.isArray(data.first_name)) {
            errorMessage = data.first_name.join(", ");
          } else if (data.last_name && Array.isArray(data.last_name)) {
            errorMessage = data.last_name.join(", ");
          } else if (
            data.non_field_errors &&
            Array.isArray(data.non_field_errors)
          ) {
            errorMessage = data.non_field_errors.join(", ");
          } else if (typeof data === "string") {
            errorMessage = data;
          }
        }
      } else if (error.request) {
        // Request was made but no response received
        errorMessage =
          "Не удалось подключиться к серверу. Проверьте интернет-соединение.";
      } else {
        // Something else happened
        errorMessage = error.message || "Неизвестная ошибка";
      }

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = () => {
    console.log("failed");
  };

  return (
    <div className="page login registration">
      {loading && (
        <Spin
          indicator={
            <LoadingOutlined
              style={{
                fontSize: 32,
              }}
              spin
            />
          }
        />
      )}
      <div className="login__panel">
        <div className="login__panel__title">Регистрация</div>
        {success ? (
          <div className="login__content">
            <Alert
              message="Спасибо за регистрацию!"
              description="Ваша заявка находится на модерации. Мы активируем ваш аккаунт после проверки. Это может занять некоторое время. Мы свяжемся с вами как только всё будет готово!"
              type="success"
              showIcon
            />
            <div className="register" style={{ marginTop: "20px" }}>
              <Link to="/login">Перейти ко входу</Link>
            </div>
          </div>
        ) : (
          <>
            <Form
              name="registration"
              style={{ maxWidth: 300 }}
              onFinish={onSubmit}
              onFinishFailed={onFinishFailed}
              autoComplete="on"
              layout="vertical"
            >
            {error && (
              <div>
                <Alert message={error} type="error" showIcon />
                <br />
              </div>
            )}
            <Form.Item
              label="Логин"
              name="username"
              rules={[
                {
                  required: true,
                  message: "Обязательное поле",
                },
              ]}
            >
              <Input placeholder="Какой будет логин?" size="large" />
            </Form.Item>
            <Form.Item
              label="Имя"
              name="first_name"
              rules={[
                {
                  required: true,
                  message: "Обязательное поле",
                },
              ]}
            >
              <Input placeholder="Как вас зовут?" size="large" />
            </Form.Item>
            <Form.Item
              label="Фамилия"
              name="last_name"
              rules={[
                {
                  required: true,
                  message: "Обязательное поле",
                },
              ]}
            >
              <Input placeholder="Ваша фамилия" size="large" />
            </Form.Item>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  type: "email",
                  message: "Введите правильный email",
                },
                {
                  required: true,
                  message: "Обязательное поле",
                },
              ]}
            >
              <Input placeholder="Ваш email" size="large" />
            </Form.Item>
            <Form.Item
              label="Номер телефона"
              rules={[
                {
                  required: true,
                  message: "Обязательное поле",
                },
              ]}
            >
              <Input
                placeholder="Введите номер телефона"
                value={phoneInputValue}
                onChange={handlePhoneInputChange}
                size="large"
                addonBefore={
                  <Select
                    value={selectedCountry}
                    onChange={handleCountryChange}
                    style={{ width: 120 }}
                  >
                    {countries.map((country) => (
                      <Option key={country.code} value={country.code}>
                        {country.flag} {country.prefix}
                      </Option>
                    ))}
                  </Select>
                }
              />
            </Form.Item>
            <Form.Item
              label="Страна"
              name="country"
              rules={[
                { required: true, message: "Пожалуйста, выберите страну" },
              ]}
            >
              <Select placeholder="Выберите страну" size="large">
                <Option value="Кыргызстан">Кыргызстан</Option>
                <Option value="Казахстан">Казахстан</Option>
                <Option value="Узбекистан">Узбекистан</Option>
                <Option value="Россия">Россия</Option>
                <Option value="Белоруссия">Белоруссия</Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="Пароль"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Введите пароль",
                },
                {
                  min: 8,
                  message: "Пароль должен содержать как минимум 8 символов",
                },
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();

                    // Check for purely numeric passwords
                    if (/^\d+$/.test(value)) {
                      return Promise.reject(
                        new Error("Пароль не должен состоять только из цифр"),
                      );
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input.Password size="large" />
            </Form.Item>
            <Form.Item
              label="Подтвердите пароль"
              name="confirm_password"
              dependencies={["password"]}
              rules={[
                {
                  required: true,
                  message: "Подтвердите пароль",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Пароли не совпадают"));
                  },
                }),
              ]}
            >
              <Input.Password size="large" />
            </Form.Item>
            <Button type="primary" htmlType="submit" block>
              Зарегистрироваться
            </Button>
            <div className="register" style={{ marginTop: "20px" }}>
              <span>Есть аккаунт?</span>&nbsp;&nbsp;
              <Link to="/login">Войти</Link>
            </div>
            </Form>
            <div className="login__content">
              <div className="login__divider">или</div>
              <GoogleOperatorAuth
                mode="signup"
                onError={setError}
                onLoadingChange={setLoading}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Registration;
